import React from "react";
import { DatePicker, Space, Select } from "antd";
import Lang from "../../lang";
import services from "../../services";
import { Input } from "@progress/kendo-react-inputs";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import { ConfigProvider } from "antd";
import pt_BR from "antd/es/locale/pt_PT";
import locale from "antd/es/date-picker/locale/zh_CN";

import DateRange from "./DateRange.jsx";
import LocationSelection from "../common/LocationSelection";
const { RangePicker } = DatePicker;
var moment = require("moment");
const dateFormat = "YYYY-MM-DD";
const dateShowFormat = "dd/MMM/yyyy";

const locationKeys = [
    {
        name: "distrito_id",
        display: "Distrito",
        valueKey: "cod",
        searchKey: "coddis",
        targetName: "desdis",
    },
    {
        name: "country_id",
        display: "Concelho",
        valueKey: "cod",
        searchKey: "codcon",
        targetName: "descon",
    },
    {
        name: "fregusia_id",
        display: "Freguesia",
        valueKey: "codfrg",
        searchKey: "codfrg",
        targetName: "desfrg",

        // searchKey : "dicofre"
    },
];

class FilterInputs extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            form: {},
            filterTabs: {},
            dropDownFilter: "",
            selectedDropDown: "",
            inputBox: "",
            radioBox: "",
            selectFilterOption: "",
            filtervalue: "",
            locationFilter: {
                Distrito: "",
                Concelho: "",
                Fregusia: "",
            },
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.handleSelectFilterTab();
        this.setState({
            selectFilterOption: "",
        });
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        // services.lablecheck.setlable()
        if (preProp.date !== this.props.date) {
            this.setState(
                {
                    selectFilterOption: "",
                },
                () => this.createInputBox()
            );
        }
    }

    getLocationData = (key, value, listObj) => {
        console.log("the tri values for location are ", key, value);
        let newValue = "";
        let newName = "";
        let newKey = "";
        let targetObj;
        let locationFilter = this.state.locationFilter;
        locationKeys.map((_r) => {
            if (_r.name == key) {
                // console.log("listObj[key]",value,key, listObj[key].find(_dist => _dist.coddis == value))
                if (listObj[key]) {
                    if (key !== "fregusia_id") {
                        console.log("the list obj is", listObj);
                        targetObj = listObj[key].find(
                            (_dist) => _dist[_r.searchKey] == value
                        );
                        if (targetObj) {
                            newValue = targetObj[_r.valueKey];
                            newName = targetObj[_r.targetName];
                        }
                    } else {
                        console.log("the list obj is", listObj);
                        targetObj = listObj[key].find(
                            (_dist) => _dist[_r.searchKey] == value
                        );
                        if (targetObj) {
                            newValue = targetObj[_r.valueKey];
                            newName = targetObj[_r.targetName];

                            if (
                                newValue < 10 &&
                                newValue.toString().length < 2
                            ) {
                                newValue = "0" + newValue;
                            } else {
                                newValue = newValue.toString();
                            }
                        }
                    }
                }
                newKey = _r.display;
            }
        });

        // console.log("newvaleue",newKey,newValue,key,listObj,value)
        let data = {
            target: {
                value: newValue,
            },
        };
        locationFilter = { ...this.state.locationFilter, [newKey]: value };
        this.setState(
            {
                locationFilter,
            },
            () => this.props.handleInputChange(newKey, data, newName)
        );
    };

    handleInputChange = (keyname, e) => {
        this.props.handleInputChange(keyname, e);
        let form = { ...this.state.form };
        if (form[e.target.name] === undefined) form[e.target.name] = "";
        form[e.target.name] = e.target.value;
        this.setState(
            {
                form,
            },
            () => {
                this.createInputBox();
            }
        );
    };

    handleInputBox = (e) => {
        let form = { ...this.props.filters };
        form["combobox"] = e.target.value;
        console.log("Handle input box runnninggggggg");
        this.setState(
            {
                form,
            },
            () => {
                this.createInputBox();
            }
        );
    };

    createInputBox = () => {
        let combeval = this.state.form.combobox;
        let updateFilter = this.props.updateFilters;
        console.log("update filter isssssssssss", updateFilter);
        let locationFilter =
            Object.keys(updateFilter).length === 0
                ? {}
                : this.state.locationFilter;
        let defaultValueRangePicker;
        console.log("comboevallll", combeval);
        if (!combeval) return;
        let optionVar = this.props.filters.Tabs[this.state.selectedDropDown];
        let inputOption = optionVar[combeval];
        console.log("optionvar is     ", optionVar);
        console.log("inputoption is     ", inputOption);

        if (inputOption.inputType === "RangePicker") {
            let startDate = null;
            let endDate = null;
            if (Object.keys(updateFilter).length === 0) {
                defaultValueRangePicker = { start: null, end: null };
                console.log("updaate filter first");
            } else {
                if (combeval == "0") {
                    console.log("update filter second", updateFilter);
                    Object.keys(updateFilter).map((_k) => {
                        if (
                            _k === "DataCriadoStart" ||
                            _k === "DataCriadoEnd"
                        ) {
                            startDate = updateFilter.DataCriadoStart || null;
                            endDate = updateFilter.DataCriadoEnd || null;
                        } else if (_k === "start_date" || _k === "end_date") {
                            startDate = updateFilter["start_date"] || null;
                            endDate = updateFilter["end_date"] || null;
                        } else if (
                            _k === "startDateAposicao" ||
                            _k === "endDateAposicao"
                        ) {
                            startDate =
                                updateFilter["startDateAposicao"] || null;
                            endDate = updateFilter["endDateAposicao"] || null;
                        } else if (
                            _k === "startDateEngarrafamento" ||
                            _k === "endDateEngarrafamento"
                        ) {
                            startDate =
                                updateFilter["startDateEngarrafamento"] || null;
                            endDate =
                                updateFilter["endDateEngarrafamento"] || null;
                        } else if (
                            _k === "DataOperaçãoStart" ||
                            _k === "DataOperaçãoEnd"
                        ) {
                            startDate =
                                updateFilter["DataOperaçãoStart"] || null;
                            endDate = updateFilter["DataOperaçãoEnd"] || null;
                        } else if (
                            _k === "data inicial de login" ||
                            _k === "data final de login"
                        ) {
                            startDate =
                                updateFilter["data inicial de login"] || null;
                            endDate =
                                updateFilter["data final de login"] || null;
                            console.log(
                                "update login date",
                                startDate,
                                endDate
                            );
                        }
                    });
                } else if (combeval == "1") {
                    startDate = updateFilter.DataModificadoStart || null;
                    endDate = updateFilter.DataModificadoEnd || null;
                }
                if (startDate && endDate) {
                    defaultValueRangePicker = {
                        start: new Date(startDate),
                        end: new Date(endDate),
                    };
                } else if (startDate && !endDate) {
                    defaultValueRangePicker = {
                        start: new Date(startDate),
                        end: null,
                    };
                } else if (endDate && !startDate) {
                    defaultValueRangePicker = {
                        start: null,
                        end: new Date(endDate),
                    };
                } else {
                    defaultValueRangePicker = { start: null, end: null };
                }
                // console.log("defaultValueRangePicker", this.state.form.combobox, defaultValueRangePicker, updateFilter)
                console.log("update filter in filter input", updateFilter);
            }
        }

        let inputBox = "";
        if (inputOption) {
            this.setState({
                inputBox: null,
                locationFilter,
            });
            switch (inputOption.inputType) {
                case "text":
                    inputBox = (
                        <div style={{ marginTop: "10px" }}>
                            <div className="input-box mt-2 active-grey minw-4">
                                <Input
                                    type={inputOption.inputType}
                                    name={inputOption.key}
                                    value={
                                        this.props.updateFilters[
                                            inputOption.key
                                        ] || ""
                                    }
                                    style={{ width: "100%" }}
                                    className="input-1 searchfilterInputdiv"
                                    label={Lang.langCheck.langRequest(
                                        `${inputOption.displayKey}`
                                    )}
                                    onChange={(e) =>
                                        this.handleInputChange(
                                            inputOption.key,
                                            e
                                        )
                                    }
                                />
                            </div>
                        </div>
                    );
                    break;
                case "date":
                    inputBox = (
                        <div className="input-box mt-2 active-grey minw-4">
                            <DatePicker
                                className="input-1 searchfilterInputdiv"
                                label="Pesquisa por data"
                                placeholder="Pesquisa por data"
                                format={dateFormat}
                                style={{ width: "100%" }}
                                disabledDate={this.disabledDate}
                                onChange={(e) =>
                                    this.props.handleInputChange(
                                        inputOption.key,
                                        e
                                    )
                                }
                            />
                        </div>
                    );
                    break;
                case "dropdown":
                    inputBox = (
                        <div
                            style={
                                this.state.selectedDropDown === "Grupos"
                                    ? { marginTop: "30px" }
                                    : {}
                            }
                        >
                            <div className="input-box  active-grey minw-4">
                                <select
                                    className="custome-drop-down"
                                    value={
                                        this.props.updateFilters[
                                            this.state.selectedDropDown
                                        ] ||
                                        this.props.updateFilters[
                                            inputOption.key
                                        ] ||
                                        ""
                                    }
                                    onChange={(e) =>
                                        this.props.handleInputChange(
                                            inputOption.key,
                                            e
                                        )
                                    }
                                >
                                    <option value="">
                                        {this.state.selectedDropDown ===
                                        "Tipo de instalação"
                                            ? "Selecione o tipo de instalação"
                                            : this.state.selectedDropDown ===
                                                  "Grupos" &&
                                              this.state.form.combobox === "1"
                                            ? "Selecione estado"
                                            : `Selecione o ${this.state.selectedDropDown}`}{" "}
                                    </option>
                                    {inputOption.option.map((_opt, index) => (
                                        <option key={index} value={_opt.key}>
                                            {_opt.value}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    );
                    break;
                case "RangePicker":
                    inputBox = (
                        <div className="input-box mt-2 active-grey minw-4 date-range-holder">
                            <DateRange
                                inputOption={inputOption}
                                defaultValue={defaultValueRangePicker}
                                handleInputChange={(key, value) =>
                                    this.props.handleInputChange(key, value)
                                }
                            />

                            {/* <ConfigProvider locale={pt_BR}>
                                <Space direction="vertical" size={12}>
                                    <RangePicker disabledDate={this.disabledDate} onChange={(e) => this.props.handleInputChange(inputOption.key, e)} />
                                </Space>
                            </ConfigProvider>  */}
                        </div>
                    );
                    break;
                case "locationDropDowns":
                    inputBox = (
                        <div className="input-box  active-grey minw-4">
                            <div className="row">
                                <LocationSelection
                                    getLocationData={(
                                        key,
                                        value,
                                        locationData
                                    ) =>
                                        this.getLocationData(
                                            key,
                                            value,
                                            locationData
                                        )
                                    }
                                    date={new Date()}
                                    locationFor={this.state.selectedDropDown}
                                    distrito_id={
                                        +this.state.locationFilter.Distrito ||
                                        ""
                                    }
                                    country_id={
                                        +this.state.locationFilter.Concelho ||
                                        ""
                                    }
                                    fregusia_id={
                                        +this.state.locationFilter.Fregusia ||
                                        ""
                                    }
                                />
                            </div>
                        </div>
                    );
                    break;
                case "radio":
                    inputBox = <></>;
                    break;
            }
            this.setState({
                inputBox,
                selectFilterOption: combeval,
            });
        }
    };

    /*   Para desativar os dados de acordo com a condição */
    disabledDate = (current) => {
        return current && current > moment().endOf("day");
    };

    handleTab = (key) => {
        let filterTabs = {};
        Object.keys(this.props.filters.Tabs).map((_k, i) => {
            filterTabs[_k] = key === _k ? true : false;
        });
        this.setState(
            {
                filterTabs,
                selectedDropDown: key,
                inputBox: "",
                dropDownFilter: null,
                selectFilterOption: "",
            },
            () => this.DropDown()
        );
    };

    handleOptions = () => {
        let optionVar = this.props.filters.Tabs[this.state.selectedDropDown];
        //console.log("option", optionVar, this.state.selectedDropDown)
        let Options = optionVar.map((_o, i) => (
            <option key={i} value={i}>
                {Lang.langCheck.langRequest(`${_o.displayKey}`)}{" "}
            </option>
        ));
        return Options;
    };

    handleRadioBox = () => {
        let radioBox = "";
        let radioBtn;
        if (
            this.state.selectedDropDown === "Entidade" ||
            (this.state.selectedDropDown === "Autorização" &&
                this.state.selectFilterOption == 0 &&
                this.state.selectFilterOption !== "")
        ) {
            radioBtn = this.props.filters.checkbox.map((_r, i) => {
                let checkedalready =
                    this.props.deafault_selected_checkbox === _r.key
                        ? true
                        : false;
                switch (_r.inputType) {
                    case "radio":
                        radioBox = (
                            <div
                                key={i}
                                className="custom-control custom-radio custom-control-inline mt-4"
                            >
                                <input
                                    type="radio"
                                    checked={checkedalready}
                                    onChange={() =>
                                        this.props.updateCheckButton(_r.key)
                                    }
                                    className="custom-control-input"
                                    id={`customRadio${i}`}
                                    name="example"
                                    value=""
                                />
                                <label
                                    className="custom-control-label"
                                    htmlFor={`customRadio${i}`}
                                >
                                    {Lang.langCheck.langRequest(
                                        `${_r.displayKey}`
                                    )}
                                </label>
                            </div>
                        );
                        break;
                }
                return radioBox;
            });
        }
        return radioBtn;
    };

    DropDown = () => {
        //console.log("selectFilterOption", this.state.selectFilterOption);
        if (
            this.props.filters.Tabs &&
            this.props.filters.Tabs[this.state.selectedDropDown] &&
            this.props.filters.Tabs[this.state.selectedDropDown].length > 0
        ) {
            let dropDownFilter = (
                <select
                    defaultValue={this.state.selectFilterOption}
                    onChange={this.handleInputBox}
                    className="custome-drop-down"
                >
                    <option value="" disabled>
                        {Lang.langCheck.langRequest("Select Filters")}
                    </option>
                    {this.handleOptions()}
                </select>
            );
            this.setState({
                dropDownFilter,
            });
        }
    };

    handleSelectFilterTab = () => {
        let filterTabs = {};
        let selectedDropDown;
        Object.keys(this.props.filters.Tabs).map((_k, i) => {
            if (i === 0) {
                selectedDropDown = _k;
            }
            filterTabs[_k] = i === 0 ? true : false;
        });
        this.setState(
            {
                filterTabs,
                selectedDropDown,
            },
            () => this.DropDown()
        );
    };

    /*  Para renderizar o conteúdo html da página   */

    render() {
        console.log("searchform", this.state.form);
        return (
            <div className="tab-table">
                <div className="mbl-responsive">
                    <ul className="nav nav-tabs">
                        {Object.keys(this.props.filters.Tabs).map((key, i) => (
                            <li key={i} className={"nav-item"}>
                                <a
                                    className={
                                        i === 0 ? "nav-link active" : "nav-link"
                                    }
                                    onClick={() => this.handleTab(key)}
                                    data-toggle="tab"
                                    href="#tab0"
                                >
                                    {Lang.langCheck.langRequest(`${key}`)}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                {/* <FilterTabs tabs={this.props.filters.Tabs} selectedTab={this.state.filterTabs} handleSelectFilterTab={this}/>  */}
                <div className="tab-content">
                    <div className="tab-pane active" id="tab0">
                        <div className="top-section pt-0">
                            <div className="d-md-flex align-items-center">
                                {this.state.dropDownFilter && (
                                    <>
                                        <div className="input-box active-grey drop-down-box mr-3 filter-dropdown">
                                            <label className="input-label">
                                                Filtrar por{" "}
                                            </label>

                                            {this.state.dropDownFilter}
                                        </div>
                                        <div
                                            className={
                                                this.state.selectedDropDown ===
                                                    "Tipo de instalação" ||
                                                (this.state.selectedDropDown ===
                                                    "Entreposto") |
                                                    (this.state
                                                        .selectedDropDown ===
                                                        "Estado")
                                                    ? "mt-2 pt-1"
                                                    : ""
                                            }
                                        >
                                            {this.state.inputBox}
                                        </div>
                                    </>
                                )}
                                {this.handleRadioBox()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FilterInputs;
